import React from 'react';

// Utility functions (inline to avoid import issues)
const getToothType = (toothNumber) => {
  const lastDigit = toothNumber % 10;
  if (lastDigit === 1 || lastDigit === 2) return 'incisor';
  if (lastDigit === 3) return 'canine';
  if (lastDigit === 4 || lastDigit === 5) return 'premolar';
  if (lastDigit === 6 || lastDigit === 7 || lastDigit === 8) return 'molar';
  return 'incisor';
};

const getToothColor = (toothNumber, chartData) => {
  const tooth = chartData[toothNumber];
  if (!tooth) return '#ffffff';
  
  if (tooth.extracted) return '#ffebee';
  if (tooth.filled) return '#e8f5e8';
  if (tooth.decay) return '#fff3e0';
  if (tooth.crown) return '#e3f2fd';
  if (tooth.rootCanal) return '#f3e5f5';
  
  return '#ffffff';
};

const getToothPaths = (type, isUpper) => {
  const paths = {};
  
  switch (type) {
    case 'incisor':
      if (isUpper) {
        paths.crown = "M20 8 C16 8, 14 10, 14 14 C14 18, 16 22, 20 24 C24 22, 26 18, 26 14 C26 10, 24 8, 20 8 Z";
        paths.root = "M20 24 C18 24, 17 26, 17 30 C17 35, 18 40, 20 45 C22 40, 23 35, 23 30 C23 26, 22 24, 20 24 Z";
      } else {
        paths.crown = "M20 8 C16 8, 14 10, 14 14 C14 18, 16 22, 20 24 C24 22, 26 18, 26 14 C26 10, 24 8, 20 8 Z";
        paths.root = "M20 24 C18 24, 17 28, 17 34 C17 40, 18 46, 20 50 C22 46, 23 40, 23 34 C23 28, 22 24, 20 24 Z";
      }
      break;
      
    case 'canine':
      if (isUpper) {
        paths.crown = "M20 6 C16 6, 13 8, 13 13 C13 18, 16 23, 20 26 C24 23, 27 18, 27 13 C27 8, 24 6, 20 6 Z";
        paths.root = "M20 26 C18 26, 16 28, 16 32 C16 38, 17 44, 20 50 C23 44, 24 38, 24 32 C24 28, 22 26, 20 26 Z";
      } else {
        paths.crown = "M20 8 C16 8, 13 10, 13 15 C13 20, 16 24, 20 26 C24 24, 27 20, 27 15 C27 10, 24 8, 20 8 Z";
        paths.root = "M20 26 C18 26, 16 30, 16 36 C16 42, 17 48, 20 52 C23 48, 24 42, 24 36 C24 30, 22 26, 20 26 Z";
      }
      break;
      
    case 'premolar':
      if (isUpper) {
        paths.crown = "M20 8 C15 8, 12 11, 12 16 C12 21, 15 25, 20 28 C25 25, 28 21, 28 16 C28 11, 25 8, 20 8 Z";
        paths.root = "M20 28 C17 28, 15 30, 15 34 C15 39, 16 44, 20 48 C24 44, 25 39, 25 34 C25 30, 23 28, 20 28 Z";
      } else {
        paths.crown = "M20 8 C15 8, 12 11, 12 16 C12 21, 15 25, 20 28 C25 25, 28 21, 28 16 C28 11, 25 8, 20 8 Z";
        paths.root = "M20 28 C17 28, 15 32, 15 38 C15 44, 16 48, 20 50 C24 48, 25 44, 25 38 C25 32, 23 28, 20 28 Z";
      }
      break;
      
    case 'molar':
      if (isUpper) {
        paths.crown = "M20 6 C14 6, 10 10, 10 16 C10 22, 14 28, 20 30 C26 28, 30 22, 30 16 C30 10, 26 6, 20 6 Z";
        paths.root = "M15 30 C13 30, 12 32, 12 36 C12 42, 13 46, 15 48 M20 30 C20 32, 20 44, 20 48 M25 30 C27 30, 28 32, 28 36 C28 42, 27 46, 25 48";
      } else {
        paths.crown = "M20 8 C14 8, 10 12, 10 18 C10 24, 14 28, 20 30 C26 28, 30 24, 30 18 C30 12, 26 8, 20 8 Z";
        paths.root = "M15 30 C13 30, 12 34, 12 40 C12 46, 13 50, 15 52 M20 30 C20 34, 20 46, 20 52 M25 30 C27 30, 28 34, 28 40 C28 46, 27 50, 25 52";
      }
      break;
      
    default:
      paths.crown = "M20 8 C16 8, 14 10, 14 14 C14 18, 16 22, 20 24 C24 22, 26 18, 26 14 C26 10, 24 8, 20 8 Z";
      paths.root = "M20 24 C18 24, 17 26, 17 30 C17 35, 18 40, 20 45 C22 40, 23 35, 23 30 C23 26, 22 24, 20 24 Z";
  }
  
  return paths;
};

const getCrownPath = (type) => {
  switch (type) {
    case 'molar':
      return "M12 12 L16 8 L20 10 L24 8 L28 12 L26 16 L22 14 L20 16 L18 14 L14 16 Z";
    case 'premolar':
      return "M14 10 L18 8 L22 8 L26 10 L24 14 L20 12 L16 14 Z";
    default:
      return "M16 10 L20 8 L24 10 L22 14 L20 12 L18 14 Z";
  }
};

const ToothSVG = ({ number, isSelected, onClick, isUpper = true, chartData }) => {
  const toothType = getToothType(number);
  const toothColor = getToothColor(number, chartData);
  const borderColor = isSelected ? '#1890ff' : '#d9d9d9';
  const borderWidth = isSelected ? 2 : 1;
  
  const paths = getToothPaths(toothType, isUpper);
  const crownPath = getCrownPath(toothType);

  return (
    <div 
      style={{ 
        position: 'relative', 
        margin: '4px',
        cursor: 'pointer',
        border: `${borderWidth}px solid ${borderColor}`,
        borderRadius: '8px',
        padding: '8px',
        backgroundColor: toothColor,
        minWidth: '60px',
        textAlign: 'center',
        boxShadow: isSelected ? '0 4px 12px rgba(24, 144, 255, 0.3)' : '0 2px 8px rgba(0,0,0,0.1)',
        transition: 'all 0.3s ease',
        transform: isSelected ? 'scale(1.05)' : 'scale(1)'
      }}
      onClick={() => onClick(number)}
    >
      <svg width="50" height="60" viewBox="0 0 40 60">
        {/* Tooth Crown */}
        <path
          d={paths.crown}
          fill="#ffffff"
          stroke="#999999"
          strokeWidth="1"
          style={{ filter: 'drop-shadow(1px 1px 2px rgba(0,0,0,0.1))' }}
        />
        
        {/* Tooth Root(s) */}
        {toothType === 'molar' ? (
          // Multiple roots for molars
          <g>
            <path d={paths.root.split(' M')[1]} fill="none" stroke="#cccccc" strokeWidth="8" strokeLinecap="round"/>
            <path d={paths.root.split(' M')[2]} fill="none" stroke="#cccccc" strokeWidth="8" strokeLinecap="round"/>
            <path d={paths.root.split(' M')[3]} fill="none" stroke="#cccccc" strokeWidth="8" strokeLinecap="round"/>
          </g>
        ) : (
          // Single root for other teeth
          <path
            d={paths.root}
            fill="#f5f5f5"
            stroke="#cccccc"
            strokeWidth="1"
          />
        )}
        
        {/* Crown highlight */}
        <path
          d={paths.crown}
          fill="url(#toothHighlight)"
          opacity="0.4"
        />
        
        {/* Treatment markings */}
        {chartData[number]?.crown && (
          <path
            d={crownPath}
            fill="#1890ff"
            opacity="0.8"
            stroke="#0066cc"
            strokeWidth="1"
          />
        )}
        
        {chartData[number]?.filled && (
          <ellipse
            cx="20"
            cy="18"
            rx="5"
            ry="3"
            fill="#52c41a"
            opacity="0.8"
          />
        )}
        
        {chartData[number]?.decay && (
          <circle
            cx="20"
            cy="16"
            r="4"
            fill="#fa8c16"
            opacity="0.8"
          />
        )}
        
        {chartData[number]?.rootCanal && (
          <line
            x1="20"
            y1="24"
            x2="20"
            y2={toothType === 'molar' ? "45" : "42"}
            stroke="#722ed1"
            strokeWidth="2"
            opacity="0.8"
          />
        )}
        
        {chartData[number]?.extracted && (
          <g opacity="0.9">
            <line x1="8" y1="8" x2="32" y2="48" stroke="#ff4d4f" strokeWidth="3" strokeLinecap="round"/>
            <line x1="32" y1="8" x2="8" y2="48" stroke="#ff4d4f" strokeWidth="3" strokeLinecap="round"/>
          </g>
        )}
        
        {/* Gradient definitions */}
        <defs>
          <linearGradient id="toothHighlight" x1="0%" y1="0%" x2="100%" y2="100%">
            <stop offset="0%" stopColor="#ffffff" stopOpacity="0.9"/>
            <stop offset="50%" stopColor="#f8f8f8" stopOpacity="0.5"/>
            <stop offset="100%" stopColor="#e8e8e8" stopOpacity="0.2"/>
          </linearGradient>
        </defs>
      </svg>
      
      {/* Tooth number */}
      <div style={{ 
        fontSize: '10px', 
        fontWeight: 'bold', 
        marginTop: '2px',
        color: isSelected ? '#1890ff' : '#666666'
      }}>
        {number}
      </div>
      
      {/* Surface indicators */}
      <div style={{
        position: 'absolute',
        top: '6px',
        left: '50%',
        transform: 'translateX(-50%)',
        display: 'flex',
        gap: '2px'
      }}>
        <svg width="32" height="12" viewBox="0 0 32 12">
          <circle cx="6" cy="6" r="4" fill="none" stroke="#ddd" strokeWidth="0.5"/>
          <circle cx="16" cy="6" r="4" fill="none" stroke="#ddd" strokeWidth="0.5"/>
          <circle cx="26" cy="6" r="4" fill="none" stroke="#ddd" strokeWidth="0.5"/>
          
          {/* Mark affected surfaces */}
          {chartData[number]?.surface?.includes('mesial') && (
            <circle cx="6" cy="6" r="3" fill="#fa8c16" opacity="0.6"/>
          )}
          {chartData[number]?.surface?.includes('occlusal') && (
            <circle cx="16" cy="6" r="3" fill="#fa8c16" opacity="0.6"/>
          )}
          {chartData[number]?.surface?.includes('distal') && (
            <circle cx="26" cy="6" r="3" fill="#fa8c16" opacity="0.6"/>
          )}
        </svg>
      </div>
      
      {/* Status indicators */}
      {chartData[number] && (
        <div style={{ 
          position: 'absolute', 
          top: '-4px', 
          right: '-4px',
          display: 'flex',
          flexDirection: 'column',
          gap: '2px'
        }}>
          {chartData[number].extracted && (
            <div style={{ width: '8px', height: '8px', backgroundColor: '#ff4d4f', borderRadius: '50%' }} />
          )}
          {chartData[number].decay && (
            <div style={{ width: '8px', height: '8px', backgroundColor: '#fa8c16', borderRadius: '50%' }} />
          )}
          {chartData[number].filled && (
            <div style={{ width: '8px', height: '8px', backgroundColor: '#52c41a', borderRadius: '50%' }} />
          )}
        </div>
      )}
    </div>
  );
};

export default ToothSVG;